import * as React from 'react';
import cx from 'classnames';

const Icon = ({children, className}) => <i className={cx('material-icons', className)}>{children}</i>;

export default Icon;
